/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
    // Add custom code below this line

        // Get the select element
    const variants = document.querySelectorAll('.select-popout__list.custom-select .select-popout__item input');
    const selectList = document.querySelector('.select-popout__list.custom-select');

    // Listen for the change event on the select element
    variants.forEach(variant => {
        variant.addEventListener('change', function () {
            // Get the selected option

            let currentVariant = variant.value;


            // Update the data-popout-toggle-text attribute with the selected option text
            const popoutToggle = document.querySelector('.select-popout .current-variant');
            popoutToggle.setAttribute('data-popout-toggle-text', currentVariant);
            popoutToggle.innerHTML = currentVariant;

            selectList.classList.remove('popout-list--visible')
        });

    })

    //popout-list--visible

    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
